import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * Dims content and shows a centered spinner overlay while async work runs (e.g. select-triggered API).
 * Keeps previous layout visible to avoid jump; combine with useAsyncAction + disabled Select.
 */
const AsyncSection = ({
  loading,
  minHeight,
  spinnerSize = 32,
  children,
  sx,
  overlaySx,
}) => (
  <Box sx={{ position: "relative", minHeight, ...sx }}>
    <Box
      sx={{
        opacity: loading ? 0.5 : 1,
        pointerEvents: loading ? "none" : "auto",
        transition: "opacity 0.15s ease",
      }}
    >
      {children}
    </Box>
    {loading ? (
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          ...overlaySx,
        }}
      >
        <CircularProgress size={spinnerSize} />
      </Box>
    ) : null}
  </Box>
);

export default AsyncSection;
